var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex"},_vm._l((_vm.subMenuItems),function(item){return _c('b-btn',{key:item.label,staticClass:"rounded-0 border-0 w-100 py-2",class:{
                'text-primary': _vm.isCurrentView(item),
            },attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.setMessageView(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }